import { GenericError } from '@/models/generic-error';
import { ErrorService } from '@/services/ErrorService';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AxiosError } from 'axios';
import { PropsWithChildren, useState } from 'react';

function makeQueryClient(state: any) {
  return new QueryClient({
    defaultOptions: {
      hydrate: {
        queries: state,
      },
      mutations: {
        onError(error) {
          ErrorService.onError(error as AxiosError<GenericError>);
        },
        retry(failureCount: number, error: Error) {
          if (
            failureCount >=
            (error.message ==
            'errors.USER_RESTRICTIONS_EXCEEDED_MAXIMUM_ALLOWED_VALUE'
              ? 1
              : 3)
          ) {
            return true;
          }

          return (
            (error as AxiosError<GenericError>)?.response?.data?.statusCode ==
              502 || (error as AxiosError<GenericError>)?.status == 502
          );
        },
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient(state?: any) {
  if (typeof window === 'undefined') {
    return makeQueryClient(state);
  } else {
    if (!browserQueryClient) browserQueryClient = makeQueryClient(state);
    return browserQueryClient;
  }
}

export default function TanstackQueryProvider({
  children,
  state,
}: PropsWithChildren<{ state: any }>) {
  const [queryClient] = useState(() => getQueryClient(state));

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools buttonPosition="bottom-left" />
    </QueryClientProvider>
  );
}
